import axios from 'axios'

const http = axios.create({
    baseURL: '',
    timeout: 10000
})

http.interceptors.response.use(async res => {
  if (res.status == 200) {
      let { code } = res.data
      if (code == 200) return res.data.data
      else {
          return Promise.reject(res)
      }
  } else {
      return Promise.reject(res);
  }
}, error => {
  return Promise.reject(error)
})

export default http



// WEBPACK FOOTER //
// ./src/api/index.js